export default __webpack_public_path__ + "static/media/freebsd.bd69bed9.svg";